import React from 'react';
import { capitalizeFirstLetter } from '../../utils/helpers';

const ProductCard = ({ title, description, status, isActive, onClick }) => (
  <div
    className={`bg-white rounded-lg shadow-md p-3 cursor-pointer ${isActive ? 'border-2 border-blue-500 bg-gradient-to-b from-green-100 to-white' : 'border border-gray-200'}`}
    onClick={onClick}
  >
    <h3 className="text-base font-semibold text-gray-800">{capitalizeFirstLetter(title)}</h3>
    <p className="text-xs text-gray-600 mt-2">{capitalizeFirstLetter(description)}</p>
  </div>
);

export default ProductCard; 